import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserRole, Outlet, Session } from '../../types';

interface AuthState {
  user_id: string | null;
  organization_id: string | null;
  organization_name: string | null;
  logo: string | null;
  role: UserRole | null;
  outlets: Outlet[];
  session: Session | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: AuthState = {
  user_id: null,
  organization_id: null,
  organization_name: null,
  logo: null,
  role: null,
  outlets: [],
  session: null,
  isLoading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUserDetails: (state, action: PayloadAction<{
      user_id: string;
      organization_id: string;
      organization_name: string;
      logo?: string;
      role: UserRole;
      outlets: Outlet[];
    }>) => {
      const { user_id, organization_id, organization_name, logo, role, outlets } = action.payload;
      state.user_id = user_id || null;
      state.organization_id = organization_id || null;
      state.organization_name = organization_name || null;
      state.logo = logo || null;
      state.role = role || null;
      state.outlets = outlets || [];
    },
    setSession: (state, action: PayloadAction<Session | null>) => {
      state.session = action.payload;
    },
    clearAuth: (state) => {
      state.user_id = null;
      state.organization_id = null;
      state.organization_name = null;
      state.logo = null;
      state.role = null;
      state.outlets = [];
      state.session = null;
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const { setUserDetails, setSession, clearAuth, setLoading, setError } = authSlice.actions;
export default authSlice.reducer;
